import { City, useCities } from 'providers/cities';
import { FunctionComponent, useRef, useState } from 'react';
import { ReactComponent as DropdownIcon } from 'assets/icons/Dropdown.svg';
import classNames from 'classnames';
import { useClickAway } from 'react-use';
import { useId } from 'react-id-generator';

interface CititiesSelectProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export const formatCityName = (city: City) => city.cityName.split(',')[0];

const CititiesSelect: FunctionComponent<CititiesSelectProps> = ({
  className,
  ...divProps
}) => {
  const { selectedCity, cities, selectCity } = useCities();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickAway(ref, () => setOpen(false));
  const ids = useId(cities.length);
  const [loading, setLoading] = useState(false);

  return (
    <div
      ref={ref}
      className={classNames('relative select-none', className)}
      {...divProps}
    >
      <div
        onClick={() => setOpen((prev) => !prev)}
        className={classNames(
          'flex items-center pl-4 pr-2 py-2 rounded-lg border cursor-pointer relative',
          {
            'border-theme-border': open,
            'hover:border-theme-border border-transparent': !open,
          },
        )}
      >
        {!loading ? (
          <>
            <div className='capitalize mr-3'>
              {selectedCity?.cityName.split(',')[0]}
            </div>
            <DropdownIcon className='w-4 h-4' />
          </>
        ) : (
          <>
            <div className='mr-2 animate-spin w-6 h-6 border-4 border-theme-main/20 border-b-theme-main rounded-full bg-white'></div>
            <div>Keičiama...</div>
          </>
        )}
      </div>
      {!open ? null : (
        <div className='absolute left-0 w-[150px] top-full pt-2'>
          <div className='bg-white rounded border shadow'>
            {cities.map((city, i) => (
              <div
                key={ids[i]}
                onClick={() => {
                  selectCity(city.id);
                  setOpen(false);
                  setLoading(true);
                  setTimeout(() => {
                    setLoading(false);
                  }, 1000);
                }}
                className='px-4 py-2 hover:bg-black/5 cursor-pointer capitalize'
              >
                {formatCityName(city)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CititiesSelect;
